var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSingleCaptureIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 19,
    viewBox: "0 0 25 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.332 14.668H20.0966V4.332H4.332V14.668ZM0 19V0H24.4286V19H0ZM1.35714 17.6429H23.0714V1.35714H1.35714V17.6429Z",
    fill: "#16A665"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingleCaptureIcon);
export default __webpack_public_path__ + "static/media/singleCaptureIcon.682bbed7f764fd22406c8afb0084cbc8.svg";
export { ForwardRef as ReactComponent };